import { render } from "./LeadsAdmin.vue?vue&type=template&id=6399cdf9"
import script from "./LeadsAdmin.vue?vue&type=script&lang=js"
export * from "./LeadsAdmin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__